import { useEffect, useState } from "react";
import { getComparisonResearchQueryBackup } from "../services/comparisonResearchQueries";

const useFetchComparisonResearchQueryBackups = ({
  comparisonResearchQueryId,
  setIsLoading,
  page,
  pSize,
}: any) => {
  const [comparisonResearchQueryBackupData, setComparisonResearchQueryBackupData] =
    useState<any>();
  useEffect(() => {
    if (comparisonResearchQueryId && comparisonResearchQueryId > 0) {
      setIsLoading(true);
      const getComparisonResearchQueryBackupData = async () => {
        try {
          const result = await getComparisonResearchQueryBackup({
            comparisonResearchQueryId,
            page,
            pSize,
          });
          setComparisonResearchQueryBackupData(result);
        } catch (err) {
          setComparisonResearchQueryBackupData({});
        } finally {
          setIsLoading(false);
        }
      };
      getComparisonResearchQueryBackupData();
    }
  }, [comparisonResearchQueryId, page, pSize]);

  return [comparisonResearchQueryBackupData];
};

export default useFetchComparisonResearchQueryBackups;

